import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchTeamViewCounts = unaryStreamRpc({
  name: "watchTeamViewCounts",
  input: z.object({ merchantTimezone: z.string().nullish() }),
  output: z.object({
    folderCounts: z.record(z.string(), z.number()),
    viewCounts: z.record(z.string(), z.number()),
  }),
});
